import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MapPin, UtensilsCrossed } from 'lucide-react';

/**
 * Sticky mobile bottom bar: Call · Directions · Lunch
 * Only visible on screens < md (phone/small tablet) and hidden on admin pages.
 */
const MobileLunchBar = () => {
  const location = useLocation();
  const hiddenOn = ['/admin', '/admin-login'];
  if (hiddenOn.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-[9500] bg-[#1A1A1A]/95 backdrop-blur-md border-t border-[#C97A2B]/40 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-lunch-bar"
      aria-label="Pikatoiminnot"
    >
      <div className="grid grid-cols-3">
        <a
          href="tel:+358403779200"
          className="flex flex-col items-center gap-0.5 py-3 text-white hover:bg-white/5 active:bg-white/10 transition-colors"
          data-testid="mobile-call-btn"
        >
          <Phone className="w-5 h-5 text-[#C97A2B]" />
          <span className="text-[10px] uppercase tracking-wider font-semibold">Soita</span>
        </a>
        <a
          href="https://www.google.com/maps/dir/?api=1&destination=Hietasaarenkatu+18+Vaasa"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center gap-0.5 py-3 text-white hover:bg-white/5 active:bg-white/10 transition-colors border-x border-white/10"
          data-testid="mobile-directions-btn"
        >
          <MapPin className="w-5 h-5 text-[#C97A2B]" />
          <span className="text-[10px] uppercase tracking-wider font-semibold">Reitti</span>
        </a>
        <Link
          to="/menu"
          className="flex flex-col items-center gap-0.5 py-3 text-white hover:bg-white/5 active:bg-white/10 transition-colors"
          data-testid="mobile-lunch-btn"
        >
          <UtensilsCrossed className="w-5 h-5 text-[#C97A2B]" />
          <span className="text-[10px] uppercase tracking-wider font-semibold">Lounas</span>
        </Link>
      </div>
    </nav>
  );
};

export default MobileLunchBar;
